class VariantRadios extends HTMLElement {
  constructor() {
    super();

    // is this a multiseason product?
    const multiSeason = document.getElementById(`ship-options-${this.dataset.section}`);

    //onload; radio inputs enabled by default
    //if desktop, disable radio inputs
    this.swapFields();

    //onresize
    //if desktop, disable radio inputs
    //if mobile, enable radio inputs    
    window.addEventListener('resize', debounce((event) => {
      this.swapFields();
      if(multiSeason) {
        this.handleSeasons();
      }
    }, 300).bind(this));

    this.addEventListener('change', this.onVariantChange);

    if(multiSeason) {
      //hide out of season variants
      this.handleSeasons();
      multiSeason.addEventListener('change', this.handleSeasons);
    }
   
  }

  onVariantChange(e) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if(productForm.querySelector('.BIS_trigger')) {
      productForm.querySelector('.BIS_trigger').setAttribute('data-variant-id', e.target.value);
    }

    var label = e.target.nextElementSibling;
    if(label.classList.contains("quantity__button") ){
      this.checkButton(false);
    }
    else {
      var qty = label.querySelector('span:first-child').innerText;
      if(label.querySelector('.variant-radios--price .sale-price')){
        var price_part = label.querySelector('.variant-radios--price .sale-price span').innerText;
        var price = label.querySelector('.variant-radios--price .sale-price').innerText.replace(price_part, '').replace(/^[\r\n]+|[\r\n]+$/g, '');
      }
      else if(label.querySelector('.variant-radios--price .igPrice')){
        var price = label.querySelector('.variant-radios--price .igPrice').innerText;
      }
      else {
        var price = label.querySelector('.variant-radios--price').innerText;
      }
      this.updateQtyLabel(qty);
      this.updatePriceLabel(price);
      this.checkButton(price);
    }
  }

  updateQtyLabel(qty) {
    const qtyLabel = document.getElementById(`product-form-${this.dataset.section}-qty-label`).querySelector('span');
    qtyLabel.innerText = qty;
  }

  updatePriceLabel(price) {
    const priceLabel = document.getElementById(`product-form-${this.dataset.section}-price-label`);
    priceLabel.innerText = price;
  }

  checkButton(price) {
//console.log('checkButton', price);
    if(this.querySelector('input[type=radio]:checked') && this.querySelector('input[type=radio]:checked').classList.contains('available')) {
      this.toggleAddButton(false, price, true);
    } else {
      this.toggleAddButton(true, price, true);
      this.setUnavailable();
    }
    if(this.querySelector('input[type=number]').value <= 0) {
      this.toggleAddButton(true, price, true, 'zeroed');
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true, extraClass = '') {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      //addButton.setAttribute('disabled', 'disabled');
      addButton.classList.add('notify-disabled');
      if (text) addButtonText.textContent = text;
      if (extraClass) addButton.classList.add(extraClass);
      //add click action to show the message 
      addButton.addEventListener('click',function(event) {
        if(addButton.classList.contains('notify-disabled')) {
          event.preventDefault();
          productForm.querySelector('.atc-notify').classList.add('show');
        }
      });
    } else {
      //addButton.removeAttribute('disabled');
      addButton.classList.remove('notify-disabled');
      if(!text){
        addButtonText.innerHTML = window.variantStrings.addToCart;
      }
      else{
        addButtonText.innerHTML = window.variantStrings.addToCart + (text ? "<span> - " + text + "</span>": '');
      }
      if (extraClass) addButton.classList.remove(extraClass);
      productForm.querySelector('.atc-notify').classList.remove('show');
    }
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.addToCart;
  }

  swapFields() {
    if(this.classList.contains('simple') || this.classList.contains('cbb')) {
      return;
    }
    let width = document.body.clientWidth;
    if(width > 768) {
      this.querySelectorAll('input').forEach((field,index) => {
        field.setAttribute('disabled','');
      });
    } else {
      this.querySelectorAll('input').forEach((field,index) => {
        field.disabled = false;
      });
      this.checkButton();
    }
  }

  handleSeasons() {
    let width = document.body.clientWidth;
    //if(width <= 768) {
      let selected = document.querySelector('input[name="showseason"]:checked').value;
      let optionsContainer = document.querySelector('variant-radios');
      let prechecked = false;
      optionsContainer.querySelectorAll('.season').forEach((field,index) => {
        field.classList.add("visually-hidden");
        field.querySelector('input').checked = false;
        if(field.classList.contains(selected)) {
          field.classList.remove("visually-hidden");
          if(!prechecked && field.querySelector('input.available')) {
            field.querySelector('input.available').checked = true;
            prechecked = true;
          }
        }
      });
      optionsContainer.checkButton();
    //}
  }

}

customElements.define('variant-radios', VariantRadios);

class VariantTable extends VariantRadios {
  constructor() {
    super();
  }

  checkButton() {
    let atc = false;
    this.querySelectorAll('input[type=number]').forEach((field,index) => {
      // if we have quantities greater than 0 in any field
      if(field.value > 0) {
        atc = true;
      }
    });
    if(atc) {
      this.toggleAddButton(false, '', true);
    } else {
      this.toggleAddButton(true, '', true);
    }
  }

  swapFields() {
    let width = document.body.clientWidth;
    if(width <= 768) {
      this.querySelectorAll('input').forEach((field,index) => {
        field.setAttribute('disabled','');
      });
    } else {
      this.querySelectorAll('input').forEach((field,index) => {
        field.disabled = false;
      });
      this.checkButton();
    }
  }

  handleSeasons() {
    let width = document.body.clientWidth;
    if(width > 768) {
      var selected = document.querySelector('input[name="showseason"]:checked').value;
      var optionsContainer = document.querySelector('variant-table');
      optionsContainer.querySelectorAll('tr.season').forEach((field,index) => {
        field.classList.add("visually-hidden");
        if(field.querySelector('input.quantity__input')) {
          //reset all the values to prevent accidental add to cart of hidden options
          field.querySelector('input.quantity__input').value = 0;
          optionsContainer.checkButton();
        }
        if(field.classList.contains(selected)) {
          field.classList.remove("visually-hidden");
        }
      });
    }
  }
}
customElements.define('variant-table', VariantTable);

document.querySelectorAll('.BIS_trigger').forEach(function(button) {
  button.addEventListener('click',function(event) {
    window.dataLayer.push({
      event: 'eb_productBISClick',
      variantId: event.target.dataset.variantId
    });
  });
});